/**
 * Normalizes internal app.hackernoon.com URLs or relative paths into relative routes
 * suitable for React Router <Link to={...}>. Returns null if the URL is an external link.
 *
 * @param {string} url - The URL string to inspect
 * @returns {string|null} Relative path (e.g. "/inbox") or null if external
 */
export const getInternalPath = url => {
  if (!url) return null;
  if (url.startsWith("https://app.hackernoon.com") || url.startsWith("http://app.hackernoon.com")) {
    const path = url.replace(/^https?:\/\/app\.hackernoon\.com/, "");
    return path || "/";
  }
  if (url.startsWith("/") || !url.startsWith("http")) {
    return url.startsWith("/") ? url : `/${url}`;
  }
  return null;
};
